import LocationList from "../Features/Shared/Locations/locationList";

const Locations = () => {
    return (
        <div>
            <LocationList />
        </div>
    )
}

export default Locations;